export default __webpack_public_path__ + "static/media/marko_s.ed4e5fc5.jpg";